const logoPropertyConfig = {
  name: 'Logo',
  edit: {
    form: 'image-input',
    label: 'Change Logo',
    handler: value => value,
    onDelete: (deleteField) => deleteField(),
  },
};
export default logoPropertyConfig;
